var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 px-0"},[_vm._v("Redirecionando...")])
}
var staticRenderFns = []

export { render, staticRenderFns }